import { minorDigitsForCurrency } from '@tenant/shared';
/** Money inputs are exact minor-unit strings. Never round a customer's input. */
export function parseCashAmount(input, allowZero = false, currency = 'AZN') {
    const value = input.trim().replace(/\s/g, '').replace(',', '.');
    let scale;
    try {
        scale = minorDigitsForCurrency(currency);
    }
    catch {
        return null;
    }
    if (value.length > 32 || !new RegExp(`^\\d+${scale ? `(?:\\.\\d{1,${scale}})?` : ''}$`).test(value))
        return null;
    const [whole = '', fraction = ''] = value.split('.');
    const minor = BigInt(whole) * 10n ** BigInt(scale) + BigInt(fraction.padEnd(scale, '0') || '0');
    if (minor.toString().length > 30)
        return null;
    return minor > 0n || (allowZero && minor === 0n) ? minor.toString() : null;
}
export function cashAmountInput(minor, currency = 'AZN') {
    const value = BigInt(minor);
    const absolute = value < 0n ? -value : value;
    const scale = minorDigitsForCurrency(currency), divisor = 10n ** BigInt(scale);
    return `${value < 0n ? '-' : ''}${absolute / divisor}${scale ? ',' + String(absolute % divisor).padStart(scale, '0') : ''}`;
}
export function formatCashMinor(minor, currency, locale = 'ru') {
    const value = BigInt(minor);
    const absolute = value < 0n ? -value : value;
    const scale = minorDigitsForCurrency(currency), divisor = 10n ** BigInt(scale);
    const whole = new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(absolute / divisor);
    const decimal = new Intl.NumberFormat(locale).formatToParts(1.1).find(part => part.type === 'decimal')?.value || ',';
    return `${value < 0n ? '−' : ''}${whole}${scale ? decimal + String(absolute % divisor).padStart(scale, '0') : ''} ${currency}`;
}
/** Signed historical corrections are explicit administrative input; regular money inputs stay nonnegative. */
export function parseSignedCashAmount(input, currency = 'AZN') {
    const value = input.trim();
    const negative = value.startsWith('-');
    const amount = parseCashAmount(negative ? value.slice(1) : value, true, currency);
    return amount === null ? null : negative && amount !== '0' ? '-' + amount : amount;
}
